import $ from 'jquery'

export const bp = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1440
}

export class Core {

  static isProd () {
    const hostname = window.location.hostname.toLowerCase();
    const url = window.location.href.toLowerCase();

    // Check if we're in a local/development environment
    const devPatterns = [
      'local',
      'localhost',
      '127.0.0.1',
      '.test',
      '.dev',
      'staging',
      'preprod',
      '.mkt.',
    ];

    return !devPatterns.some(pattern => hostname.includes(pattern) || url.includes(pattern));
  }

  static isAdmin () {
    return $('body').hasClass('wp-admin')
  }

  static isAdminFront () {
    return $('body').hasClass('admin-bar')
  }

  static getCurrentBp () {
    let window_width = $(window).width()

    if (window_width >= bp.xxl) {
      return 'xxl'
    } else if (window_width >= bp.xl) {
      return 'xl'
    } else if (window_width >= bp.lg) {
      return 'lg'
    } else if (window_width >= bp.md) {
      return 'md'
    } else if (window_width >= bp.sm) {
      return 'sm'
    } else {
      return 'xs'
    }
  }

  static scrollTo ($item, time) {
    if (! time) {
      time = 300
    }

    $('body, html').animate({
      scrollTop: $item.offset().top - $('header').height() - 50
    }, time)
  }

  static isBpGreaterThan (bpTest) {
    if (bp.hasOwnProperty(bpTest)) {
      let window_width = $(window).width()

      if (window_width > bp[bpTest]) {
        return true
      }
    }

    return false
  }

  static isBpLessThan (bpTest) {
    if (bp.hasOwnProperty(bpTest)) {
      let window_width = $(window).width()

      if (window_width <= bp[bpTest]) {
        return true
      }
    }

    return false
  }

  /**
   * Teste une media query exposée par le CSS (ex: $bp-header → --mq-header), pour ne pas dupliquer les breakpoints en JS
   */
  static matchesMedia (name) {
    const query = getComputedStyle(document.documentElement).getPropertyValue(`--mq-${name}`).trim()

    return query !== '' && window.matchMedia(query).matches
  }

  static activeBodyScroll () {
    $('html').removeClass('disable-overflow')
  }

  static disableBodyScroll () {
    $('html').addClass('disable-overflow')
  }

}
